import { useSelector } from 'react-redux'

import '../../gestionar_cuenta/gestionarCuenta.css'

import { AjustesGenerales } from './AjustesGenerales'
import { AjustesRentabilidad } from './AjustesRentabilidad'

export const AjustesPptos = () => {

    const { unitList, currencyList, listaFormasPagosVentas, detail } = useSelector(state => state.general)

    return (
        <div className='container'>
            <AjustesGenerales
                unitList={unitList}
                currencyList={currencyList}
                listaFormasPagosVentas={listaFormasPagosVentas}
                detail={detail}
            />
            <AjustesRentabilidad
                unitList={unitList}
            />
        </div>
    )
}